import { Loader, XCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';
import { useGetTreatmentCheckInQuery } from '@/services/api/treatmentService';

import { CheckInPageWrapper } from './CheckInPageWrapper';
import { EditCheckInForm } from './EditCheckInForm';

const EditCheckInContent = ({ checkInId }: { checkInId: string }) => {
  const { matterId } = useMatter();
  const navigate = useNavigate();

  const { data: checkIn, isLoading } = useGetTreatmentCheckInQuery({
    matterId,
    checkInId,
  });

  const handleCancel = () => {
    navigate(`/matters/${matterId}/treatment/check-ins`);
  };

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px]">
        <Loader
          className="animate-spin h-8 w-8 text-blue-500 mb-3"
          aria-label="Loading spinner"
        />

        <span className="text-gray-600 text-base font-medium">
          Loading check-in details...
        </span>
      </div>
    );
  }

  if (!checkIn) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px]">
        <XCircle
          className="h-8 w-8 text-red-400 mb-3"
          aria-label="Error icon"
        />
        <span className="text-red-600 text-base font-medium">
          Check-in not found.
        </span>
      </div>
    );
  }

  return (
    <CheckInPageWrapper>
      <EditCheckInForm checkIn={checkIn} onCancel={handleCancel} />
    </CheckInPageWrapper>
  );
};

export const EditCheckInPage = () => {
  const { check_in_id } = useParams<{ check_in_id: string }>();

  if (!check_in_id) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px]">
        <XCircle
          className="h-8 w-8 text-red-400 mb-3"
          aria-label="Error icon"
        />
        <span className="text-red-600 text-base font-medium">
          Check-in not found. Bad route.
        </span>
      </div>
    );
  }

  return <EditCheckInContent checkInId={check_in_id} />;
};
